async function getAllArtists(opts) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await fetch(
      `${API_BASE_URL}/public/get-all-artists${buildPaginationQuery(opts)}`,
      { signal: controller.signal },
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch artists: ${response.status}`);
    }
    return await response.json();
  } finally {
    clearTimeout(timeoutId);
  }
}

async function getArtistsBriefs() {
  const response = await fetch(`${API_BASE_URL}/public/artists-briefs`);
  if (!response.ok) {
    throw new Error(`Failed to fetch artist briefs: ${response.status}`);
  }
  return response.json();
}

async function createArtistsBriefSubmission(submission) {
  const response = await fetch(
    `${API_BASE_URL}/public/artists-briefs/submissions`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(submission),
    },
  );
  if (!response.ok) {
    throw new Error(`Failed to submit: ${response.status}`);
  }
  return response.json();
}

async function getArtistById(artistId) {
  const response = await fetch(`${API_BASE_URL}/public/artist/${artistId}`);
  if (!response.ok) {
    throw new Error(`Failed to fetch artist: ${response.status}`);
  }
  return response.json();
}

function buildPaginationQuery(opts) {
  const params = new URLSearchParams();
  if (opts && opts.page !== undefined) params.set("page", String(opts.page));
  if (opts && opts.pageSize !== undefined) {
    params.set("pageSize", String(opts.pageSize));
  }
  if (opts && opts.sort) params.set("sort", opts.sort);
  const query = params.toString();
  return query ? `?${query}` : "";
}

async function getArtistCollections(artistId, opts) {
  const response = await fetch(
    `${API_BASE_URL}/public/artist/${artistId}/collections${buildPaginationQuery(opts)}`,
  );
  if (!response.ok) {
    throw new Error(`Failed to fetch artist collections: ${response.status}`);
  }
  return response.json();
}

async function getArtistKlydos(artistId, opts) {
  const response = await fetch(
    `${API_BASE_URL}/public/artist/${artistId}/klydos${buildPaginationQuery(opts)}`,
  );
  if (!response.ok) {
    throw new Error(`Failed to fetch artist klydos: ${response.status}`);
  }
  return response.json();
}

async function getArtistCollectionsDownloadStats(artistId) {
  const response = await fetch(
    `${API_BASE_URL}/public/artist/${artistId}/collections/download-stats`,
  );
  if (!response.ok) {
    throw new Error(
      `Failed to fetch collection download stats: ${response.status}`,
    );
  }
  return response.json();
}

async function createNewArtistsContactSubmission(submission) {
  const response = await fetch(`${API_BASE_URL}/public/new-artists/contact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(submission),
  });
  if (!response.ok) {
    throw new Error(`Failed to submit: ${response.status}`);
  }
  const text = await response.text();
  return text ? JSON.parse(text) : null;
}
